import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconArrowDownward.tsx
const OutlinedFilledArrowDownward = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-826v511L201-547l-66 67 345 345 346-345-67-67-232 232v-511h-94Z" })
});
const OutlinedArrowDownward = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-826v511L201-547l-66 67 345 345 346-345-67-67-232 232v-511h-94Z" })
});
const RoundedFilledArrowDownward = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-315v-463q0-19.88 13.5-33.94Q460-826 480-826t33.5 14.06Q527-797.88 527-778v463l198-198q14-14 33.67-14.58 19.68-.58 33.93 13.5 14.4 14.08 13.9 33.9T792-446L514-168q-7.17 6.91-16.19 10.95-9.03 4.05-17.92 4.05-8.89 0-17.84-4.05Q453.1-161.09 446-168L168-447q-15-15.5-15-34.25T168.23-514q14.07-14 32.92-14T234-514l199 199Z" })
});
const RoundedArrowDownward = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-315v-463q0-19.88 13.5-33.94Q460-826 480-826t33.5 14.06Q527-797.88 527-778v463l198-198q14-14 33.67-14.58 19.68-.58 33.93 13.5 14.4 14.08 13.9 33.9T792-446L514-168q-7.17 6.91-16.19 10.95-9.03 4.05-17.92 4.05-8.89 0-17.84-4.05Q453.1-161.09 446-168L168-447q-15-15.5-15-34.25T168.23-514q14.07-14 32.92-14T234-514l199 199Z" })
});
const SharpFilledArrowDownward = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-826v511L201-547l-66 67 345 345 346-345-67-67-232 232v-511h-94Z" })
});
const SharpArrowDownward = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-826v511L201-547l-66 67 345 345 346-345-67-67-232 232v-511h-94Z" })
});
const componentMap = {
	outlined: OutlinedArrowDownward,
	"outlined-fill": OutlinedFilledArrowDownward,
	rounded: RoundedArrowDownward,
	"rounded-fill": RoundedFilledArrowDownward,
	sharp: SharpArrowDownward,
	"sharp-fill": SharpFilledArrowDownward
};
const IconArrowDownward = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconArrowDownward };